/**
 * Activity 2F: Otolith Examination
 */
export default [
    {
        path: '/otolith/',
        name: 'state_2f',
        pathToRegexpOptions: { strict: true },
        component: () => import(/* webpackChunkName: "sst" */ '../views/2f_otolith/Otolith_2f_Index.vue')
    },
    {
        path: '/otolith/model/',
        name: 'state_2f_a',
        pathToRegexpOptions: { strict: true },
        component: () => import(/* webpackChunkName: "sst" */ '../views/2f_otolith/Otolith_2f_a_Model.vue')
    },
    {
        path: '/otolith/video/',
        name: 'state_2f_b',
        pathToRegexpOptions: { strict: true },
        component: () => import(/* webpackChunkName: "sst" */ '../views/2f_otolith/Otolith_2f_b_Video.vue')
    },
    {
        path: '/otolith/setup/',
        name: 'state_2f_c',
        pathToRegexpOptions: { strict: true },
        component: () => import(/* webpackChunkName: "sst" */ '../views/2f_otolith/Otolith_2f_c_Setup.vue')
    },
    {
        path: '/otolith/trace/:index/',
        name: 'state_2f_d',
        pathToRegexpOptions: { strict: true },
        component: () => import(/* webpackChunkName: "sst" */ '../views/2f_otolith/Otolith_2f_d_Trace.vue')
    },
    {
        path: '/otolith/plot/',
        name: 'state_2f_e',
        pathToRegexpOptions: { strict: true },
        component: () => import(/* webpackChunkName: "sst" */ '../views/2f_otolith/Otolith_2f_e_Plot.vue')
    },
    {
        path: '/otolith/trendline/',
        name: 'state_2f_f',
        pathToRegexpOptions: { strict: true },
        component: () => import(/* webpackChunkName: "sst" */ '../views/2f_otolith/Otolith_2f_f_Trendline.vue')
    },
    {
        path: '/otolith/reflection/',
        name: 'state_2f_g',
        pathToRegexpOptions: { strict: true },
        component: () => import(/* webpackChunkName: "sst" */ '../views/2f_otolith/Otolith_2f_g_Reflection.vue')
    },
    
]